import { render, staticRenderFns } from "./driver_manager_risk_matrix.vue?vue&type=template&id=f5e3e612&scoped=true&"
import script from "./driver_manager_risk_matrix.vue?vue&type=script&lang=js&"
export * from "./driver_manager_risk_matrix.vue?vue&type=script&lang=js&"
import style0 from "./driver_manager_risk_matrix.vue?vue&type=style&index=0&id=f5e3e612&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e3e612",
  null
  
)

export default component.exports